module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-public"
  }, [_c('div', {
    staticClass: "do-public__header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.calendarName))])]), _vm._v(" "), _c('div', {
    staticClass: "do-public__body"
  }, [(!_vm.calendar) ? _c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : _c('div', [_c('SmartScreen', {
    attrs: {
      "calendarId": _vm.calendarId
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('span', {
    staticClass: "icon-docendo",
    attrs: {
      "id": "d-icon"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c2af81c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/DesktopVue.vue
// module id = 1527
// module chunks = 1